import type { PublishPlatform, PublishUiStatus } from './types';

export function mapPublishStatus(
  status: string | null | undefined,
  platform: PublishPlatform,
): PublishUiStatus {
  if (!status) return 'none';

  if (status === 'pending' || status === 'processing') return 'publishing';
  if (status === 'failed') return 'failed';
  if (
    status === 'published'
    && (platform === 'youtube' || platform === 'instagram' || platform === 'tiktok' || platform === 'facebook')
  ) {
    return 'published';
  }
  if (status === 'sent_to_drafts' && platform === 'tiktok') return 'in_drafts';

  return 'none';
}
